<template>
  <div class="container pedidos">
    <div class="container section text-center pt-1">
      <div class="row justify-content-center">
        <div :class="clasesAnchoContenido">
          <n-button
            class="float-right"
            type="primary"
            round
            simple
            @click="modals.modalMiniAlertaCerrarSesion = true"
          >
            Cerrar sesión
          </n-button>
        </div>
      </div>
      <div class="row text-left justify-content-center pb-3">
        <div :class="clasesAnchoContenido">
          <div class="nombre-usuario informacion col-sm-12">
            <!-- <span> -->
            <!-- <i class="fas fa-user"></i> -->
            <!-- <span class="ml-2">
                {{ nombreUsuario }}
              </span> -->
            <!-- </span> -->
            <span class="texto-nombre-usuario">
              <i class="fas fa-user"></i>
              {{ nombreUsuario }}</span
            >
          </div>
          <div class="informacion badge-container col-sm-12 my-2">
            <!-- <span>
              <i class="fas fa-id-card"></i>
              <span class="ml-2">
                {{ numeroAMoneda(numeroDocumento) }}
              </span>
            </span> -->
            <span class="badge badge-danger">
              <i class="fas fa-id-card"></i>
              {{ numeroAMoneda(numeroDocumento) }}</span
            >
          </div>
          <div class="informacion badge-container col-sm-12">
            <span class="badge badge-danger">
              <i class="fas fa-hand-holding-usd"></i>
              {{ porcentajeDescuento }} %</span
            >
            <!-- <span>
              <i class="fas fa-hand-holding-usd"></i>
              <span class="ml-2"> {{ porcentajeDescuento }} % </span>
            </span> -->
          </div>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-sm-12 col-md-10 col-lg-7">
          <table
            class="table table-sm table-striped table-hover table-responsive"
          >
            <thead>
              <tr>
                <th scope="col" class="encabezado-columna-cantidad">
                  Cantidad
                </th>
                <th scope="col" class="encabezado-columna-borrar"></th>
                <th scope="col" class="encabezado-columna-producto">
                  Producto
                </th>
                <th scope="col" class="encabezado-columna-total">Total</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="producto in productos" :key="producto.id">
                <td class="align-middle pr-2">
                  <fg-input
                    placeholder="0"
                    v-model="producto.cantidad"
                    @input="calcularTotalProducto(producto)"
                    @keypress="restrictChars($event)"
                    type="number"
                    min="0"
                    step="1"
                  >
                  </fg-input>
                </td>
                <td class="borrar-cantidad-producto align-middle text-center">
                  <i
                    class="fa fa-backspace fa-lg"
                    @click="borrarCantidadProducto(producto)"
                  ></i>
                </td>
                <td class="nombre-producto align-middle text-left pl-4">
                  {{ producto.nombre }}
                </td>
                <td class="total-producto align-middle">
                  ${{ numeroAMoneda(producto.total) }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="text-left">
          <h4>Comentarios:</h4>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="textarea-container" :class="clasesAnchoContenido">
          <textarea
            class="form-control textarea"
            name="comentario"
            rows="4"
            cols="80"
            v-model="comentario"
            placeholder="Escribe aqui tu comentario..."
          ></textarea>
        </div>
      </div>
      <div class="row justify-content-center">
        <div :class="clasesAnchoContenido" class="text-right">
          <table class="table table-borderless">
            <tbody>
              <tr>
                <th scope="row">Subtotal:</th>
                <td class="columna-valores">
                  ${{ numeroAMoneda(calcularSubTotalPedido) }}
                </td>
              </tr>
              <tr>
                <th scope="row">Descuento:</th>
                <td>${{ numeroAMoneda(calcularDescuentoPedido) }}</td>
              </tr>
              <tr class="total-pedido">
                <th scope="row">Total pedido:</th>
                <td class="valor-total-pedido">
                  <strong> ${{ numeroAMoneda(calcularTotalPedido) }} </strong>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="row justify-content-center d-none d-md-block">
        <n-button
          type="danger"
          round
          simple
          class="mr-sm-5"
          size="lg"
          @click.native="modals.modalMiniConfirmarBorrarTodo = true"
          :disabled="botonBorrarInactivo"
        >
          Borrar todo
        </n-button>
        <n-button
          type="info"
          round
          size="lg"
          @click.native="modals.modalMiniConfirmarEnvioPedido = true"
          :disabled="botonEnviarInactivo"
        >
          Enviar pedido
        </n-button>
      </div>
      <div class="row justify-content-center d-inline d-md-none">
        <n-button
          class="btn-block"
          type="info"
          round
          size="lg"
          @click.native="modals.modalMiniConfirmarEnvioPedido = true"
          :disabled="botonEnviarInactivo"
        >
          Enviar pedido
        </n-button>
        <n-button
          type="danger"
          round
          simple
          class="btn-block"
          size="lg"
          @click.native="modals.modalMiniConfirmarBorrarTodo = true"
          :disabled="botonBorrarInactivo"
        >
          Borrar todo
        </n-button>
      </div>
      <!-- small modal Borrar Pedido-->
      <modal
        :show.sync="modals.modalMiniConfirmarBorrarTodo"
        class="modal-danger"
        :show-close="false"
        headerClasses="justify-content-center"
        type="mini"
      >
        <div slot="header" class="modal-profile">
          <i class="fas fa-exclamation fa-4x"></i>
        </div>
        <h4>¿Desea borrar todo el pedido?</h4>
        <template slot="footer">
          <n-button
            type="neutral"
            link
            @click.native="modals.modalMiniConfirmarBorrarTodo = false"
          >
            <strong>NO</strong>
          </n-button>
          <n-button type="neutral" link @click.native="borrarTodasCantidades()">
            <strong>SI</strong>
          </n-button>
        </template>
      </modal>
      <!-- small modal Enviar Pedido-->
      <modal
        :show.sync="modals.modalMiniConfirmarEnvioPedido"
        class="modal-info"
        :show-close="false"
        headerClasses="justify-content-center"
      >
        <div slot="header" class="modal-profile">
          <i class="fas fa-exclamation fa-4x"></i>
        </div>
        <div v-if="!enviandoPedido">
          <h4>¿Desea enviar este pedido?</h4>
          <div class="row">
            <table class="tabla-revisar-pedido my-2" width="100%">
              <thead>
                <tr>
                  <th>Cantidad</th>
                  <th>Producto</th>
                  <th>Precio</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(producto, index) in productos"
                  :key="index"
                  v-if="producto.cantidad !== null && producto.cantidad !== 0"
                >
                  <td>{{ numeroAMoneda(producto.cantidad) }}</td>
                  <td class="text-left">{{ producto.nombre }}</td>
                  <td>{{ numeroAMoneda(producto.total) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <h5 class="text-right">
            Subtotal pedido: ${{ numeroAMoneda(valorSubTotalPedido) }}
          </h5>
          <h5 class="text-right">
            Descuento: ${{ numeroAMoneda(valorPorcentaje) }}
          </h5>
          <h3 class="text-right">
            Total pedido: ${{ numeroAMoneda(valorTotalPedido) }}
          </h3>
        </div>
        <div v-if="enviandoPedido">
          <div class="spinner-border text-light" role="status">
            <span class="sr-only">Loading...</span>
          </div>
          <h2>Enviando...</h2>
        </div>
        <template slot="footer" v-if="!enviandoPedido">
          <n-button
            type="neutral"
            link
            @click.native="modals.modalMiniConfirmarEnvioPedido = false"
          >
            <strong>REGRESAR</strong>
          </n-button>
          <n-button type="neutral" link @click.native="enviarPedido()">
            <strong>ENVIAR</strong>
          </n-button>
        </template>
      </modal>
      <!-- small modal Success Envio pedido-->
      <modal
        :show.sync="modals.modalMiniSuccessEnvioPedido"
        class="modal-success"
        :show-close="true"
        headerClasses="justify-content-center"
        type="mini"
      >
        <div slot="header" class="modal-profile">
          <i class="fas fa-check fa-4x"></i>
        </div>
        <h4>Su pedido se ha enviado correctamente</h4>
      </modal>
      <!-- small modal Fail Envio pedido-->
      <modal
        :show.sync="modals.modalMiniFailEnvioPedido"
        class="modal-danger"
        :show-close="true"
        headerClasses="justify-content-center"
        type="mini"
      >
        <div slot="header" class="modal-profile">
          <i class="fas fa-exclamation fa-4x"></i>
        </div>
        <h4>Ha habido un error al enviar su pedido, intentelo nuevamente</h4>
      </modal>
      <!-- small modal Alerta Cerrar Sesion-->
      <modal
        :show.sync="modals.modalMiniAlertaCerrarSesion"
        class="modal-danger"
        :show-close="false"
        headerClasses="justify-content-center"
        type="mini"
      >
        <div slot="header" class="modal-profile">
          <i class="fas fa-exclamation fa-4x"></i>
        </div>
        <div v-if="cerrandoSesion">
          <div class="spinner-border text-light" role="status">
            <span class="sr-only">Cerrando sesión...</span>
          </div>
        </div>
        <h4 v-if="!cerrandoSesion">¿Está seguro que desea cerrar sesión?</h4>
        <template slot="footer" v-if="!cerrandoSesion">
          <n-button
            type="neutral"
            link
            @click.native="modals.modalMiniAlertaCerrarSesion = false"
          >
            <strong>NO</strong>
          </n-button>
          <n-button type="neutral" link @click.native="cerrarSesion()">
            <strong>SI</strong>
          </n-button>
        </template>
      </modal>
    </div>
  </div>
</template>
<script>
import { Button, FormGroupInput, Modal } from "@/components";
import { Popover } from "element-ui";
import { Auth } from "aws-amplify";
export default {
  mounted: function() {
    this.iniciandoSesion = true;
    this.usuarioEstaLogueado();
    //this.getUsuariosPorcentajes()
  },
  name: "pedidos",
  components: {
    [Button.name]: Button,
    [FormGroupInput.name]: FormGroupInput,
    [Popover.name]: Popover,
    Modal,
  },
  data() {
    return {
      nombreUsuario: "",
      numeroDocumento: "",
      porcentajeDescuento: 0,
      valorSubTotalPedido: 0,
      valorPorcentaje: 0,
      valorTotalPedido: 0,
      botonBorrarInactivo: false,
      botonEnviarInactivo: false,
      iniciandoSesion: false,
      enviandoPedido: false,
      cerrandoSesion: false,
      comentario: "",
      usuariosCedulaPorcentaje: [],
      productos: [
        {
          id: 0,
          cantidad: null,
          codigo: "220001",
          nombre: "PAN TAJADO PREMIUM",
          precio: 3600,
          total: 0,
        },
        {
          id: 1,
          cantidad: null,
          codigo: "220002",
          nombre: "PAN TAJADO ESPECIAL",
          precio: 3000,
          total: 0,
        },
        {
          id: 2,
          cantidad: null,
          codigo: "220003",
          nombre: "PAN TAJADO CASERO",
          precio: 2600,
          total: 0,
        },
        {
          id: 3,
          cantidad: null,
          codigo: "220004",
          nombre: "PAN TAJADO MEDIO",
          precio: 1800,
          total: 0,
        },
        {
          id: 4,
          cantidad: null,
          codigo: "260001",
          nombre: "PAN RELLENO DE QUESO DISPLEY X 15 UDS",
          precio: 14000,
          total: 0,
        },
        {
          id: 5,
          cantidad: null,
          codigo: "250001",
          nombre: "PAN ALIÑADO CON QUESO X 30 G",
          precio: 420,
          total: 0,
        },
        {
          id: 6,
          cantidad: null,
          codigo: "210006",
          nombre: "PAN ALIÑADO CON UVAS PASAS X 35 G",
          precio: 420,
          total: 0,
        },
        {
          id: 7,
          cantidad: null,
          codigo: "210007",
          nombre: "PAN ALIÑADO CON QUESO X 100 G",
          precio: 1300,
          total: 0,
        },
        {
          id: 8,
          cantidad: null,
          codigo: "190001",
          nombre: "GALLETA DE QUESO SP DISPLAY X 15 UDS",
          precio: 11200,
          total: 0,
        },
        {
          id: 9,
          cantidad: null,
          codigo: "190002",
          nombre: "GALLETA DE NARANJA SP DOMO X 30 UDS",
          precio: 5000,
          total: 0,
        },
        {
          id: 10,
          cantidad: null,
          codigo: "270001",
          nombre: "LENGUA SP DISPLAY X 15 UDS",
          precio: 3600,
          total: 0,
        },
        {
          id: 11,
          cantidad: null,
          codigo: "270002",
          nombre: "PALITROQUE SP X 10 UDS",
          precio: 1200,
          total: 0,
        },
        {
          id: 12,
          cantidad: null,
          codigo: "180001",
          nombre: "TORTA NARANJA X 16 PORCIONES",
          precio: 9000,
          total: 0,
        },
        {
          id: 13,
          cantidad: null,
          codigo: "280001",
          nombre: "ROSCA DISPLAY X 12 UDS",
          precio: 9500,
          total: 0,
        },
        {
          id: 14,
          cantidad: null,
          codigo: "280002",
          nombre: "ROSCON DE QUESO PAQUETE X 16 UDS",
          precio: 3600,
          total: 0,
        },
        {
          id: 15,
          cantidad: null,
          codigo: "280003",
          nombre: "DIABOLIN DISPLAY X 25 UDS",
          precio: 6500,
          total: 0,
        },
        {
          id: 16,
          cantidad: null,
          codigo: "280004",
          nombre: "ROSCA DISPLAY X 20 UDS",
          precio: 19500,
          total: 0,
        },
        {
          id: 17,
          cantidad: null,
          codigo: "170001",
          nombre: "PAN DOMOS",
          precio: 700,
          total: 0,
        },
        {
          id: 18,
          cantidad: null,
          codigo: "240001",
          nombre: "MOGOLLA ALIÑADA DISPLAY X 20 UDS",
          precio: 5000,
          total: 0,
        },
        {
          id: 19,
          cantidad: null,
          codigo: "210005",
          nombre: "PAN CASERO X 35 G",
          precio: 420,
          total: 0,
        },
        {
          id: 20,
          cantidad: null,
          codigo: "230001",
          nombre: "PAN MANTEQUILLA SP INDIVIDUAL X 50 G",
          precio: 600,
          total: 0,
        },
        {
          id: 21,
          cantidad: null,
          codigo: "210008",
          nombre: "PAN ALIÑADO CON UVAS PASAS X 75 G",
          precio: 820,
          total: 0,
        },
        {
          id: 22,
          cantidad: null,
          codigo: "270004",
          nombre: "PAN DE SAL X 40 G",
          precio: 420,
          total: 0,
        },
        {
          id: 23,
          cantidad: null,
          codigo: "270005",
          nombre: "TOSTADA PAQUETE X 12 UDS",
          precio: 1200,
          total: 0,
        },
        {
          id: 24,
          cantidad: null,
          codigo: "190003",
          nombre: "GALLETA LIMON SP DISPLAY X 12 UDS",
          precio: 5000,
          total: 0,
        },
        {
          id: 25,
          cantidad: null,
          codigo: "240002",
          nombre: "MOGOLLA MORENA DE TRIGO X 35 G",
          precio: 420,
          total: 0,
        },
        {
          id: 26,
          cantidad: null,
          codigo: "210003",
          nombre: "PAN OCAÑERO SP X 200 G",
          precio: 1600,
          total: 0,
        },
        {
          id: 27,
          cantidad: null,
          codigo: "220005",
          nombre: "PAN TAJADO MEDIO POPULAR",
          precio: 1400,
          total: 0,
        },
        {
          id: 28,
          cantidad: null,
          codigo: "270006",
          nombre: "TOSTADA DISPLEY X 20 UDS",
          precio: 5000,
          total: 0,
        },
        {
          id: 29,
          cantidad: null,
          codigo: "210001",
          nombre: "PAN CASERO X 90 G",
          precio: 820,
          total: 0,
        },
        {
          id: 30,
          cantidad: null,
          codigo: "280006",
          nombre: "ROSQUITA IND DISPLAY X 50 UDS",
          precio: 8200,
          total: 0,
        },
        {
          id: 31,
          cantidad: null,
          codigo: "280005",
          nombre: "ROSQUITAS PAQUETE X 100 G",
          precio: 5000,
          total: 0,
        },
        {
          id: 32,
          cantidad: null,
          codigo: "210004",
          nombre: "PAN REY SP X 300 G",
          precio: 2500,
          total: 0,
        },
        {
          id: 33,
          cantidad: null,
          codigo: "240005",
          nombre: "MOGOLLA OCAÑERA SP X 40 G",
          precio: 425,
          total: 0,
        },
        {
          id: 34,
          cantidad: null,
          codigo: "210012",
          nombre: "PAN DE CHOCOLATE",
          precio: 400,
          total: 0,
        },
        {
          id: 35,
          cantidad: null,
          codigo: "190010",
          nombre: "GALLETA RIZADA DOMO X 40 UDS",
          precio: 6300,
          total: 0,
        },
        {
          id: 36,
          cantidad: null,
          codigo: "280008",
          nombre: "LOLITAS DISPLAY X 15 UDS",
          precio: 5500,
          total: 0,
        },
        {
          id: 37,
          cantidad: null,
          codigo: "230007",
          nombre: "CORAZON DISPLAY X 30 UDS",
          precio: 11000,
          total: 0,
        },
        {
          id: 38,
          cantidad: null,
          codigo: "230008",
          nombre: "CORAZON DISPLAY X 15 UDS",
          precio: 5500,
          total: 0,
        },
      ],
      modals: {
        modalMiniConfirmarBorrarTodo: false,
        modalMiniConfirmarEnvioPedido: false,
        modalMiniSuccessEnvioPedido: false,
        modalMiniFailEnvioPedido: false,
        modalMiniAlertaCerrarSesion: false,
      },
      clasesAnchoContenido: ["col-sm-12", "col-md-10", "col-lg-7"],
    };
  },
  methods: {
    // calcularTotalProducto(id) {
    //   console.log("calcularTotalProducto");
    //   console.log(this.producto[id]);
    //   if (this.productos[id].cantidad !== null) {
    //     let totalPrecioProducto =
    //       this.productos[id].cantidad * this.productos[id].precio;
    //     this.productos[id].total = totalPrecioProducto;
    //   }
    // },
    calcularTotalProducto(producto) {
      let totalPrecioProducto = producto.cantidad * producto.precio;
      this.productos[producto.id].total = totalPrecioProducto;
    },
    borrarCantidadProducto(producto) {
      this.productos[producto.id].cantidad = null;
      this.calcularTotalProducto(producto);
    },
    borrarTodasCantidades() {
      this.productos.forEach((producto) => {
        this.borrarCantidadProducto(producto);
      });
      this.modals.modalMiniConfirmarBorrarTodo = false;
      window.scrollTo(0, 0);
    },
    restrictChars: function($event) {
      //Restringir para solo aceptar numeros con el teclado
      if (
        $event.charCode === 0 ||
        /\d/.test(String.fromCharCode($event.charCode))
      ) {
        return true;
      } else {
        $event.preventDefault();
      }
    },
    numeroAMoneda(numero) {
      var formatter = new Intl.NumberFormat("de-DE", {
        style: "decimal",
      });
      return formatter.format(numero); /* $2,500.00 */
    },
    numeroAPorcentaje(numero) {
      var formatter = new Intl.NumberFormat("de-DE", {
        style: "percent",
        maximumSignificantDigits: 3,
      });
      return formatter.format(numero); /* $2,500.00 */
    },

    async usuarioEstaLogueado() {
      Auth.currentAuthenticatedUser({
        bypassCache: false, // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
      })
        .then((user) => {
          //Cargar datos del usuario e ir a la vista de pedidos
          //console.log("usuarioEstaLogueado - user: ", user)
          this.nombreUsuario =
            user.attributes.given_name +
            " " +
            user.attributes.middle_name +
            " " +
            user.attributes.family_name;
          this.numeroDocumento = user.username;
          this.getUsuariosPorcentajes();
          this.iniciandoSesion = false;
        })
        .catch((err) => {
          //console.log("usuarioEstaLogueado - err: ", err)
          //Ir al login
          this.$router.push("login");
        });
    },
    async cerrarSesion() {
      //console.log("Cerrar sesiòn")
      this.cerrandoSesion = true;
      Auth.signOut()
        .then((data) => {
          //console.log(data)
          this.$router.push("login");
        })
        .catch((err) => {
          //console.log(err)
          this.cerrandoSesion = false;
        });
    },
    async enviarPedido() {
      this.enviandoPedido = true;
      this.productos.forEach((producto) => {
        if (producto.cantidad == null) {
          producto.cantidad = 0;
        } else {
          producto.cantidad = parseInt(producto.cantidad);
        }
      });
      this.axios
        .post(
          "https://h3tj4ozov8.execute-api.us-east-2.amazonaws.com/dev/pedidos",
          {
            usuario: {
              nombre: this.nombreUsuario,
              cedula: this.numeroDocumento,
              porcentaje: this.porcentajeDescuento * 100,
            },
            productos: this.productos,
            comentario: this.comentario,
          }
        )
        .then((response) => {
          this.enviarPedidoV2();
          this.enviarPedidoV2Sort();
          //console.log("response: ", response);
          this.modals.modalMiniConfirmarEnvioPedido = false;
          this.modals.modalMiniSuccessEnvioPedido = true;
          this.enviandoPedido = false;
          window.scrollTo(0, 0);
        })
        .catch((error) => {
          //console.log("error: ", error);
          this.modals.modalMiniFailEnvioPedido = true;
          this.enviandoPedido = false;
        });
    },
    async enviarPedidoV2() {
      this.axios
        .post("https://9yzu3ha8lb.execute-api.us-east-2.amazonaws.com/orders", {
          usuario: {
            nombre: this.nombreUsuario,
            cedula: this.numeroDocumento,
            porcentaje: this.porcentajeDescuento,
          },
          productos: await this.quitarProductosSinCantidad(),
          comentario: this.comentario,
          subtotal: this.valorSubTotalPedido,
          descuento: this.valorPorcentaje,
          total: this.valorTotalPedido,
        })
        .then((response) => {
          //console.log(response);
        })
        .catch((error) => {
          console.log("Error" + error);
        });
    },
    async enviarPedidoV2Sort() {
      this.axios
        .post("https://9gtm0o98gk.execute-api.us-east-2.amazonaws.com/orders", {
          user: {
            nombre: this.nombreUsuario,
            cedula: this.numeroDocumento,
            porcentaje: this.porcentajeDescuento,
          },
          products: await this.quitarProductosSinCantidad(),
          comment: this.comentario,
          subtotal: this.valorSubTotalPedido,
          discount: this.valorPorcentaje,
          total: this.valorTotalPedido,
        })
        .then((response) => {
          //console.log(response);
        })
        .catch((error) => {
          console.log("Error" + error);
        });
    },
    async getUsuariosPorcentajes() {
      await this.axios
        .get(
          "https://h3tj4ozov8.execute-api.us-east-2.amazonaws.com/dev/pedidos"
        )
        .then((response) => {
          //console.log("get - response: ", response);
          this.usuariosCedulaPorcentaje = response;
          this.usuariosCedulaPorcentaje.data.forEach((usuario) => {
            if (this.numeroDocumento == usuario.cedula) {
              this.porcentajeDescuento = usuario.porcentaje;
            }
            this.porcentajeDescuento;
          });
        })
        .catch(function(error) {
          //console.log("get - error: ", error);
        });
    },
    async quitarProductosSinCantidad() {
      let productos = await this.productos.filter(
        (producto) => producto.cantidad > 0
      );
      //console.log(productos);
      return productos;
    },
  },
  computed: {
    calcularSubTotalPedido() {
      this.valorSubTotalPedido = 0;
      this.productos.forEach((producto) => {
        this.valorSubTotalPedido += producto.total;
      });
      return this.valorSubTotalPedido;
    },
    calcularDescuentoPedido() {
      this.valorPorcentaje =
        (this.valorSubTotalPedido * this.porcentajeDescuento) / 100;
      return this.valorPorcentaje;
    },
    calcularTotalPedido() {
      this.valorTotalPedido = this.valorSubTotalPedido - this.valorPorcentaje;

      if (this.valorTotalPedido == 0) {
        this.botonBorrarInactivo = true;
        this.botonEnviarInactivo = true;
      } else {
        this.botonBorrarInactivo = false;
        this.botonEnviarInactivo = false;
      }
      return this.valorTotalPedido;
    },
  },
};
</script>
<style>
.pedidos {
  min-height: calc(100vh - 200px);
}

.informacion {
  font-size: 20px;
}

.informacion i {
  color: rgb(255, 255, 255);
}
.borrar-cantidad-producto {
  color: rgb(195, 22, 50);
}
.encabezado-columna-cantidad {
  width: 15%;
}
.encabezado-columna-producto {
  width: 55%;
}
.encabezado-columna-total {
  width: 120%;
}
.total-pedido {
  font-size: 25px;
}
.columna-valores {
  width: 25%;
}

.textarea {
  font-size: large !important;
  margin-bottom: 2em;
}

.badge {
  font-size: large !important;
  background-color: rgb(195, 22, 50) !important;
  border-color: rgb(195, 22, 50) !important;
  padding: 0.5em 0.5em !important;
}

.badge-container {
  padding: 0px !important;
}

.floating-button {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 1000;
}

.tabla-revisar-pedido {
  width: 100%;
  border: black 1px;
  border-collapse: collapse;
  background-color: #f5f5f5; /* Color de fondo gris suave */
  color: black;
}

.tabla-revisar-pedido th,
.tabla-revisar-pedido td {
  padding: 12px;
  color: #333; /* Texto en gris oscuro */
}

.tabla-revisar-pedido th {
  background-color: #d6eaf8; /* Encabezado gris azulado claro */
  color: #1a5276; /* Texto en azul oscuro para los encabezados */
  font-weight: bold;
}

/* Estilo para filas tipo cebra */
.tabla-revisar-pedido tr:nth-child(even) {
  background-color: #f8f9f9; /* Gris muy claro */
}

.tabla-revisar-pedido tr:nth-child(odd) {
  background-color: #ecf0f1; /* Gris claro */
}

/* Alineación de columnas */
.tabla-revisar-pedido th:nth-child(1), 
.tabla-revisar-pedido td:nth-child(1) /* Cantidad */ {
  text-align: center;
}

.tabla-revisar-pedido th:nth-child(2),
.tabla-revisar-pedido td:nth-child(2),
.tabla-revisar-pedido th:nth-child(3), 
.tabla-revisar-pedido td:nth-child(3)  /* Precio */ {
  /* Producto */
  text-align: left;
}

.nombre-usuario {
  background-color: #c31632;
  color: white;
  font-weight: bold;
  margin-bottom: 1rem;
  padding: 0.25em 0.25em;
  border-radius: 0.875rem;
}
</style>
